const COMPONENT_TYPE = {
  backgroundImageCard: 'backgroundImageCard',
  textWithAccordionListItemsCard: 'textWithAccordionListItemsCard',
  textBannerLarge: 'textBannerLarge',
  centeredImageWithText: 'centeredImageWithText',
  textBlock: 'textBlock',
  iconListItemsAccordion: 'iconListItemsAccordion',
  pricingSection: 'pricingSection',
  stickyButton: 'stickyButton',
  textBannerSmall: 'textBannerSmall',
  contentSectionListCard: 'contentSectionListCard',
};

export default COMPONENT_TYPE;
